<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('child_reports.resident') + ' ' + $t('globalTrans.list') }}</h4>
        </template>
      <template v-slot:body>
        <b-row>
                <b-col lg="6" sm="12" md="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="fiscal_year_id"
                        >
                        <template v-slot:label>
                        {{$t('globalTrans.fiscal_year')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.fiscal_year_id"
                        id="fiscal_year_id"
                        :options="fiscalYearList"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="organiation_id"
                        >
                        <template v-slot:label>
                            {{$t('globalTrans.organization')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.org_id"
                        :options="orgList"
                        id="organiation_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="office_type_id"
                        >
                        <template v-slot:label>
                            {{$t('child_configuration.institute_type')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.office_type_id"
                        :options="officeTypeList"
                        id="office_type_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="office_id"
                        >
                        <template v-slot:label>
                            {{$t('child_configuration.institute_name')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="search.office_id"
                        :options="officeList"
                        id="office_id"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="text-right">
                    <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
            <template v-slot:body>
                <b-row v-if="loaded">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                            <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                            <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                            <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                            <div class="titleDiv">
                              <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('child_reports.resident_list') }}</span><br>
                            </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                        <b-button-group>
                            <b-button @click="pdfExport" variant="success" class="mr-2">{{  $t('globalTrans.export_pdf') }}</b-button>
                            <b-button variant="warning">
                              <export-excel
                                worksheet="Report Sheet"
                                :title=headerValue
                                :data=excelData
                                name="resident-list.xls">
                                {{ $t('globalTrans.export_excel') }}
                              </export-excel>
                            </b-button>
                        </b-button-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                      <b-row>
                        <b-col xs="12" sm="12" md="6" class="text-left">
                            <div v-if="titleData.org_name" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ titleData.org_name }}</div>
                            <span v-if="titleData.institute_type_name" class="text-center text-dark"><b>{{ $t('child_configuration.institute_type') }} </b>: {{ titleData.institute_type_name }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-right">
                            <div v-if="titleData.institute_name" class="text-dark"><b>{{ $t('child_configuration.institute_name') }} </b>: {{ titleData.institute_name }}</div>
                            <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ titleData.year }}</span>
                        </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <b-overlay :show="loadingState">
                    <b-row>
                        <b-col lg="12" xs="12" md="12">
                            <b-table thead-class="bg-primary" bordered hover :items="report_data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                              <template v-slot:cell(index)="data">
                                {{ $n(data.index + 1) }}
                              </template>
                              <template v-slot:cell(candidate_image)="data">
                                  <b-img width='80px' height="50px" :src="childServiceBaseUrl+'download-attachment?file=uploads/admission/online-admission/candidate-imageoriginal/' + data.item.candidate_image" alt="Candidate Image"></b-img>
                              </template>
                              <template v-slot:cell(age)="data">
                                <span class="capitalize">
                                    {{ $n(data.item.age) + ' ' + $t('globalTrans.year') }}
                                </span>
                              </template>
                              <template v-slot:cell(action)="data">
                                  <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                              </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="xl" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId" :key="editItemId" :url="childServiceBaseUrl"/>
    </b-modal>
  </b-container>
</template>
<script>

import DetailModal from '../../../child-admission-management/pages/online-admission-application/DetailModal'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { onlineAdmissionList } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import ExportExcel from './export-excel'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [RouteBasedList],
  components: {
     DetailModal
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        report: 2
      },
      titleData: {
        year: '',
        org_name: '',
        institute_type_name: '',
        institute_name: ''
      },
      editItemId: 0,
      childServiceBaseUrl: childServiceBaseUrl,
      officeTypeList: [],
      officeList: [],
      report_data: [],
      rows: [],
      reportHeadData: '',
      loaded: false
    }
  },
  computed: {
    detailTitle () {
        return this.$t('child_admission_management.online_admission_application') + ' ' + this.$t('globalTrans.details')
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    excelData: function () {
      return ExportExcel.excelBody(this)
    },
    headerValue: function () {
      const title = this.$t('child_reports.resident') + ' ' + this.$t('globalTrans.list')
      return ExportExcel.headerData(title)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('child_reports.photo'), class: 'text-left' },
          { label: this.$t('globalTrans.name'), class: 'text-left' },
          { label: this.$t('child_admission_management.father_name'), class: 'text-left' },
          { label: this.$t('child_admission_management.mother_name'), class: 'text-left' },
          { label: this.$t('globalTrans.age'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'candidate_image' },
          { key: 'name_bn' },
          { key: 'father_name_bn' },
          { key: 'mother_name_bn' },
          { key: 'age' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'candidate_image' },
          { key: 'name' },
          { key: 'father_name' },
          { key: 'mother_name' },
          { key: 'age' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeTypeList()
       this.getOrgName()
      } else {
        this.titleData.org_name = ''
      }
    },
    'search.office_type_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeList()
       this.getOfficeTypeName()
      } else {
        this.titleData.institute_type_name = ''
      }
    },
    'search.office_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeName()
      } else {
        this.titleData.institute_name = ''
      }
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
        this.getFiscalYear()
        this.report_data = []
      } else {
          this.titleData.year = ''
          this.report_data = []
      }
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
                this.getOrgName()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
                this.getOfficeTypeName()
            }
            if (this.search.office_id) {
                this.getOfficeName()
            }
            if (this.search.fiscal_year_id) {
              this.getFiscalYear()
            }
            this.headerName()
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.headerName()
  },
  mounted () {
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
    getFiscalYear () {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.search.fiscal_year_id)
        if (this.$i18n.locale === 'bn') {
            this.titleData.year = Year.text_bn
        } else {
            this.titleData.year = Year.text_en
        }
    },
    searchData () {
      this.loadData()
    },
    getOrgName () {
      const Org = this.$store.state.commonObj.organizationProfileList.find(item => item.status === 0 && item.value === this.search.org_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.org_name = Org.text_bn
      } else {
          this.titleData.org_name = Org.text_en
      }
    },
    getOfficeTypeName () {
      const Org = this.$store.state.commonObj.officeTypeList.find(item => item.status === 0 && item.value === this.search.office_type_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_type_name = Org.text_bn
      } else {
          this.titleData.institute_type_name = Org.text_en
      }
    },
    getOfficeName () {
      const Org = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === this.search.office_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_name = Org.text_bn
      } else {
          this.titleData.institute_name = Org.text_en
      }
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const params = Object.assign({}, this.search)
      RestApi.getData(childServiceBaseUrl, onlineAdmissionList, params).then(response => {
        if (response.success) {
            this.report_data = this.getRelationalData(response.data)
            this.$store.dispatch('setList', this.getRelationalData(response.data))
            // this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
      let tmpFiscalYear = {}
      let tmpInstitute = {}
      const listData = data.map(item => {
          tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscal => fiscal.value === item.fiscal_year_id && fiscal.status === 0)
          tmpInstitute = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id && office.status === 0)
          const getAge = Math.floor((new Date() - new Date(item.date_of_birth).getTime()) / 3.15576e+10)
          const admissionData = {
              fiscal_year: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
              fiscal_year_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
              institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
              institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : '',
              age: getAge
          }
          return Object.assign({}, item, admissionData)
      })
      return listData
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(childServiceBaseUrl, 'configuration/report-heading/detail', 2)
       this.reportHeadData = headdata
       this.loaded = true
    },
   pdfExport () {
      const reportTitle = this.$t('child_reports.resident_list')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, this.report_data, this, this.titleData)
    }
  }
}
</script>
<style scoped>
.reportTitle {
  font-weight: bold;
    border: 1px solid;
    padding: 8px 15px 8px 15px;
    border-radius: 11px;
}
.titleDiv {
  margin-top: 1.2rem;
  font-size: 18px;
}
</style>
